import React from "react";

import { ListItem, ListItemSecondaryAction, ListItemText, List as MuiList, Divider, Typography } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { translate } from "jazasoft";

import { useDeepMemo, useSafeState } from "../../../hooks";
import { isEmpty, syntaxHighlight } from "../../../utils/helpers";

const GenericActivityDetails = ({ userActivity, translate }) => {
  const [expanded, setExpanded] = useSafeState(false);

  const listData = useDeepMemo(() => {
    if (isEmpty(userActivity)) return [];
    let listData = [
      { label: "URL", value: userActivity?.url || "" },
      { label: "Method", value: userActivity?.method || "" },
      { label: "Params", value: userActivity?.reqParams || "" }
    ];

    return listData;
  }, [userActivity]);

  const jsonData = useDeepMemo(() => {
    if (isEmpty(userActivity)) return [];
    let jsonData = [
      { label: "Metadata", value: userActivity?.meta || "" },
      { label: "Previous Value", value: userActivity?.prevValue || "" },
      { label: "Current Value", value: userActivity?.currValue || "" },
      { label: "Request Body", value: userActivity?.reqBody || "" },
      { label: "Response Body", value: userActivity?.resBody || "" }
    ];
    return jsonData.filter(e => !isEmpty(e.value));
  }, [userActivity]);

  return (
    <div>
      <MuiList disablePadding>
        {listData.map(({ label, value }, idx) => (
          <ListItem key={idx} divider>
            <ListItemText primary={label} />
            <ListItemSecondaryAction>
              <ListItemText primary={value} />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </MuiList>
      {jsonData.map((data, idx) => (
        <Accordion key={idx} expanded={expanded === data.label} onChange={(e, isExpanded) => setExpanded(isExpanded ? data.label : false)}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>{data.label}</Typography>
          </AccordionSummary>
          <Divider />
          <AccordionDetails>
            <Divider />
            <div>
              <span
                style={{ whiteSpace: "pre", fontSize: 14 }}
                dangerouslySetInnerHTML={{
                  __html:
                    data.value.startsWith("{") || data.value.startsWith("[")
                      ? syntaxHighlight(JSON.stringify(JSON.parse(data.value), null, 4))
                      : data.value
                }}
              />
            </div>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default translate(GenericActivityDetails);
